import { BaseService } from "./../base";
export class ServiceNodeService extends BaseService {
  static get entity() {
    return "service_node";
  }
  static get name() {
    return "service_node";
  }

  static async getByDestinationNode(find_by_destination_node_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_destination_node_id/${find_by_destination_node_id}`, this.name);
  }

  static async getByDestinationNodeV2(find_by_destination_node_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_destination_node_id_v2/${find_by_destination_node_id}`, this.name);
  }

  static async schedule_maintainer_start(node_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/schedule_maintainer_start/${node_id}`, null);
  }

  static async getBySpecialtyId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_specialty_id/${id}`, this.name);
  }
  static async getByUserId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_user/${id}`, this.name);
  }
}
